import { render, staticRenderFns } from "./freeTextRes.vue?vue&type=template&id=17509ce4&scoped=true&"
import script from "./freeTextRes.vue?vue&type=script&lang=js&"
export * from "./freeTextRes.vue?vue&type=script&lang=js&"
import style0 from "./freeTextRes.vue?vue&type=style&index=0&id=17509ce4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17509ce4",
  null
  
)

export default component.exports